import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'grape' | 'blush';
};
export const CHECKOUT_URL = 'https://100-ai-prompts-for-corrections-officers.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg',
  variant = 'blush'
}: Props) {
  const pad = size === 'lg' ? 'min-h-[65px] px-8 py-4 text-[17px]' : 'min-h-[58px] px-6 py-3.5 text-base';
  const skin = variant === 'blush' ? 'bg-blush text-white shadow-[0_10px_36px_-10px_rgba(194,65,12,0.7)] ring-1 ring-blush/40 hover:bg-blush-deep hover:shadow-[0_16px_46px_-10px_rgba(194,65,12,0.85)] focus-visible:ring-plum' : 'bg-grape text-white shadow-[0_10px_36px_-10px_rgba(31,78,121,0.7)] ring-1 ring-grape/40 hover:bg-grape-deep hover:shadow-[0_16px_46px_-10px_rgba(31,78,121,0.85)] focus-visible:ring-plum';
  return <a href={href} className={cn('group inline-flex w-full max-w-[360px] items-center justify-center gap-2 rounded-xl text-center font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2', skin, pad, className)} data-id="element-38" data-mp="19a7vtu9gns5q">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-39" data-mp="1s7ilqo97d98i" />
    </a>;
}